function Conversation(handler) {
    this.handler = handler;
}

Conversation.prototype.open = function(cid) {
    this.handler.onOpen(cid);
};

Conversation.prototype.respond = function(cid, r1, r2) {
    var close = r2 === undefined ? this.handler.onResponse(cid, r1) :
                                   this.handler.onResponse(cid, r1, r2);
    return close ? 'HANDLED_AND_FINISHED' : 'HANDLED_AND_ACTIVE';
};

Conversation.prototype.discard = function(cid, err) {
    this.handler.onDiscard(cid, err);
};

module.exports = Conversation;


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/conversation/conversation.js
// module id = 980
// module chunks = 1